'use client'

/**
 * Purpose: HoverGradientButton action row for camera composers (internal primitive).
 * Inputs: Action descriptors or custom children.
 * Outputs: Rendered button row.
 */

import type { ReactNode } from 'react'
import HoverGradientButton from '@/components/buttons/HoverGradientButton/HoverGradientButton'
import './Camera.css'

export type CameraActionDescriptor = {
  id: string
  label: string
  onClick: () => void
  variant?: 'filled' | 'outline'
  disabled?: boolean
  className?: string
}

/** Declarative actions or custom children for camera composer footers. */
export type CameraActionsProps = {
  actions?: CameraActionDescriptor[]
  children?: ReactNode
  className?: string
}

export function CameraActions({ actions, children, className }: CameraActionsProps) {
  // Caller supplies fully custom action markup when children are provided.
  if (children) {
    return <div className={`camera-actions ${className ?? ''}`}>{children}</div>
  }
  // Default layout maps declarative action descriptors to gradient buttons.
  return (
    <div className={`camera-actions camera-actions--center ${className ?? ''}`}>
      {actions?.map((action) => (
        <HoverGradientButton
          key={action.id}
          id={action.id}
          variant={action.variant ?? 'filled'}
          onClick={action.onClick}
          disabled={action.disabled}
          className={`cursor-pointer ${action.className ?? ''}`}
        >
          {action.label}
        </HoverGradientButton>
      ))}
    </div>
  )
}
